import { useNavigate } from "react-router-dom";
import {
    Box,
    Typography,
    Stack,
    Divider,
    Tooltip,
    Chip,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import CheckIcon from "@mui/icons-material/Check";

const ComplianceStatus = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="main_title">
                <h1>Compliance Status</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Compliance Status
                </p>
            </div>

            <div className="cards compliance" >
                {/* Overall Compliance Score */}
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Overall Compliance Score:
                </Typography>
                <Typography>"Your Compliance Status: GOOD"</Typography>

                <Box mt={2}>
                    <Typography display="inline" mr={1}>
                        Colour:
                    </Typography>
                    <CircleIcon sx={{ color: "green", fontSize: 20, verticalAlign: "middle" }} />
                </Box>

                <Box mt={1}>
                    <Typography>Or:</Typography>
                    <Stack direction="row" spacing={1} mt={1} mb={2}>
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <CircleIcon sx={{ color: "#FFB300", fontSize: 18 }} />
                            <Typography>Attention Needed</Typography>
                        </Stack>
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <CircleIcon sx={{ color: "#D32F2F", fontSize: 18 }} />
                            <Typography>At Risk</Typography>
                        </Stack>
                    </Stack>
                </Box>

                <Divider sx={{ mb: 2 }} />

                {/* Business Verification Status */}
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Business Verification Status:
                </Typography>

                <Stack spacing={1} mb={2}>
                    <Box display="flex" alignItems="center" >
                        <Typography >Business License:</Typography>
                        <CheckIcon color="success" fontSize="small" />
                        <Typography>Verified</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" >
                        <Typography >Expiry Reminder:</Typography>
                        <Typography>License expires in 40 days</Typography>
                    </Box>
                </Stack>

                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Vendor Agreement & Policy Compliance
                </Typography>

                <Stack spacing={1} mb={2}>
                    <Box display="flex" gap={2}>
                        <Typography>Terms & Conditions:</Typography>
                        <CheckIcon color="success" fontSize="small" />
                        <Typography>Accepted</Typography>
                    </Box>
                    <Box display="flex" gap={2}>
                        <Typography>Privacy Policy:</Typography>
                        <CheckIcon color="success" fontSize="small" />
                        <Typography>Accepted</Typography>
                    </Box>
                    <Box display="flex" gap={2}>
                        <Typography>Commission Policy:</Typography>
                        <CheckIcon color="success" fontSize="small" />
                        <Typography>Accepted</Typography>
                    </Box>
                    <Box display="flex" gap={2}>
                        <Typography>Last Update:</Typography>
                        <Typography>12 Jan 2025</Typography>
                    </Box>
                </Stack>

                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Product Compliance Health
                </Typography>

                <Stack spacing={1} mb={2}>
                    <Typography>Live Products: 42</Typography>
                    <Typography>Compliance Issues: 3</Typography>
                    <Typography>
                        Rejected Products: 1 (Violates image guidelines)
                    </Typography>
                    <Typography>Pending Review: 2</Typography>
                </Stack>

                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Customer Service Compliance
                </Typography>

                <Stack spacing={1}>
                    <Typography>Order Cancellation Rate: 2% (Good)</Typography>
                    <Typography>Late Shipment Rate: 4% (Acceptable)</Typography>
                    <Typography>Unanswered Customer Chats: 1 (Respond Required)</Typography>
                    <Typography>Policy Violations: 0</Typography>
                </Stack>
            </div>
        </>
    );
};

export default ComplianceStatus;
